export const salesData = [
    {
      name: "Jan",
      "Sales": 4000,
    },
    {
      name: "Feb",
      "Sales": 3000,
    },
    {
      name: "Mar",
      "Sales": 5000,
    },
    {
      name: "Apr",
      "Sales": 4000,
    },
    {
      name: "May",
      "Sales": 3000,
    },
    {
      name: "Jun",
      "Sales": 2000,
    },
    {
      name: "Jul",
      "Sales": 4000,
    },
    {
      name: "Agu",
      "Sales": 3000,
    },
    {
      name: "Sep",
      "Sales": 4000,
    },
    {
      name: "Oct",
      "Sales": 1000,
    },
    {
      name: "Nov",
      "Sales": 4000,
    },
    {
      name: "Dec",
      "Sales": 3000,
    },
  ];

  export const userData = [
    {
      id: 1,
      username: "Homer Simpson",
      avatar:
        "https://avatarfiles.alphacoders.com/693/thumb-1920-69306.jpg",
      email: "homer@simpson.com",
      status: "active",
      transaction: "$237.00",
    },
    {
      id: 2,
      username: "Marge Simpson",
      avatar:
        "https://static.simpsonswiki.com/images/0/0b/Marge_Simpson.png",
      email: "Marge@simpson.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 3,
      username: "Bart Simpson",
      avatar:
        "https://static.simpsonswiki.com/images/6/65/Bart_Simpson.png",
      email: "bart@simpson.com",
      status: "active",
      transaction: "$29.00",
    },
    {
      id: 4,
      username: "Lisa Simpson",
      avatar:
        "https://static.simpsonswiki.com/images/e/ec/Lisa_Simpson.png",
      email: "lisa@simpson.com",
      status: "active",
      transaction: "$118.00",
    },
    {
      id: 5,
      username: "Maggie Simpson",
      avatar:
        "https://upload.wikimedia.org/wikipedia/en/9/9d/Maggie_Simpson.png",
      email: "maggie@simpson.com",
      status: "active",
      transaction: "$15.00",
    },
    {
      id: 6,
      username: "Grandpa Simpson",
      avatar:
        "https://upload.wikimedia.org/wikipedia/en/3/3e/Abe_Simpson.png",
      email: "grandpa@simpson.com",
      status: "active",
      transaction: "$156.00",
    },
    {
      id: 7,
      username: "Patty Simpson",
      avatar:
        "https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Selma_Bouvier.png/132px-Selma_Bouvier.png",
      email: "patty@simpson.com",
      status: "active",
      transaction: "$32.00",
    },
    {
      id: 8,
      username: "Mona Simpson",
      avatar:
        "https://www.pngkit.com/png/detail/866-8661545_mona-simpson.png",
      email: "mona@simpson.com",
      status: "active",
      transaction: "$68.00",
    },
    {
      id: 9,
      username: "Santas Little Helper",
      avatar:
        "https://upload.wikimedia.org/wikipedia/en/8/8a/SantasLittleHelper.png",
      email: "santaslittlehelper@simpson.com",
      status: "active",
      transaction: "$123.00",
    },
    {
      id: 10,
      username: "Snowball",
      avatar:
        "https://static.simpsonswiki.com/images/a/a6/Snowball_II.png",
      email: "snowball@simpson.com",
      status: "active",
      transaction: "$34.00",
    },
  ];

  export const productData = [
    {
      id: 1,
      name: "Buzz Cola",
      img:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/BuzzCan.jpg/200px-BuzzCan.jpg",
      stock: 145,
      status: "active",
      price: "$8.00",
    },
    {
      id: 2,
      name: "Duff Beer",
      img:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Duff_beer.jpg/100px-Duff_beer.jpg",
      stock: 112,
      status: "active",
      price: "$12.00",
    },
    {
      id: 3,
      name: "Malibu Stacy",
      img:
        "https://m.media-amazon.com/images/I/915J8iG2vZL._SS500_.jpg",
      stock: 5,
      status: "active",
      price: "$15.00",
    },
    {
      id: 4,
      name: "Squishee",
      img:
        "https://i.ebayimg.com/images/g/08sAAOSwh1paA-5G/s-l300.jpg",
      stock: 79,
      status: "active",
      price: "$2.50",
    },
    {
      id: 5,
      name: "Krusty-Os",
      img:
        "https://i.ebayimg.com/images/g/u8oAAOSwGS9fTnt-/s-l400.jpg",
      stock: 24,
      status: "active",
      price: "$3.20",
    },
    {
      id: 6,
      name: "Moon Pie",
      img:
        "https://i.pinimg.com/originals/7b/7c/a0/7b7ca050acb32ccd475f53611b25edb4.jpg",
      stock: 45,
      status: "active",
      price: "$1.20",
    },
    {
      id: 7,
      name: "Malk",
      img:
        "https://ih1.redbubble.net/image.993293004.4359/st,small,507x507-pad,600x600,f8f8f8.jpg",
      stock: 77,
      status: "active",
      price: "$0.50",
    },
    {
      id: 8,
      name: "Tomacco",
      img:
        "https://static.simpsonswiki.com/images/thumb/d/db/Tomacco_Juice.png/250px-Tomacco_Juice.png",
      stock: 14,
      status: "active",
      price: "$7.00",
    },
  ];